import { render } from "./index.vue?vue&type=template&id=7c10bf2d&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=7c10bf2d&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c10bf2d"],['__file',"src/vab/layouts/VabLayoutComprehensive/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7c10bf2d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7c10bf2d', __exports__)) {
    api.reload('7c10bf2d', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=7c10bf2d&scoped=true", () => {
    api.rerender('7c10bf2d', render)
  })

}


export default __exports__